import { Component, EventEmitter, Output } from '@angular/core';

import { CacheService } from '../../../../shared/services/cache.service';
import { BaseMenuItemComponent } from '../base-menu-item.component';
import { MenuItemChild } from '../models/menu-item-child.model';
import { MenuUtilsService } from '../services/menu-utils.service';
import { MenuSharedService } from '../services/menu.shared.service';
import { Global } from './../../../../shared/constants/global.constant';

@Component({
  selector: 'antecipacoes-menu-item',
  templateUrl: '../templates/menu-item.html',
  styleUrls: ['../scss/menu-item.scss'],
})
export class AntecipacoesMenuItem extends BaseMenuItemComponent {
  menuCollapsed: boolean;
  isMobile: boolean = false;
  @Output() onClickSelect = new EventEmitter<any>();
  @Output() onClickItem = new EventEmitter<void>();

  constructor(
    menuSharedService: MenuSharedService,
    private cacheService: CacheService,
    menuUtilsService: MenuUtilsService
  ) {
    // Título, Array de Filhos, SVG, Ativo (sim ou não), altura da lista quando os subitems estiverem à mostra
    super(
      'Antecipação',
      'antecipacoes',
      [],
      `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.5 3H17.25V2.25C17.25 2.05109 17.171 1.86032 17.0303 1.71967C16.8897 1.57902 16.6989 1.5 16.5 1.5C16.3011 1.5 16.1103 1.57902 15.9697 1.71967C15.829 1.86032 15.75 2.05109 15.75 2.25V3H8.25V2.25C8.25 2.05109 8.17098 1.86032 8.03033 1.71967C7.88968 1.57902 7.69891 1.5 7.5 1.5C7.30109 1.5 7.11032 1.57902 6.96967 1.71967C6.82902 1.86032 6.75 2.05109 6.75 2.25V3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3ZM7.875 17.25C7.6525 17.25 7.43499 17.184 7.24998 17.0604C7.06498 16.9368 6.92078 16.7611 6.83564 16.5555C6.75049 16.35 6.72821 16.1238 6.77162 15.9055C6.81502 15.6873 6.92217 15.4868 7.0795 15.3295C7.23684 15.1722 7.43729 15.065 7.65552 15.0216C7.87375 14.9782 8.09995 15.0005 8.30552 15.0856C8.51109 15.1708 8.68679 15.315 8.8104 15.5C8.93402 15.685 9 15.9025 9 16.125C9 16.4234 8.88147 16.7095 8.6705 16.9205C8.45952 17.1315 8.17337 17.25 7.875 17.25ZM12 17.25C11.7775 17.25 11.56 17.184 11.375 17.0604C11.19 16.9368 11.0458 16.7611 10.9606 16.5555C10.8755 16.35 10.8532 16.1238 10.8966 15.9055C10.94 15.6873 11.0472 15.4868 11.2045 15.3295C11.3618 15.1722 11.5623 15.065 11.7805 15.0216C11.9988 14.9782 12.225 15.0005 12.4305 15.0856C12.6361 15.1708 12.8118 15.315 12.9354 15.5C13.059 15.685 13.125 15.9025 13.125 16.125C13.125 16.4234 13.0065 16.7095 12.7955 16.9205C12.5845 17.1315 12.2984 17.25 12 17.25ZM12 13.5C11.7775 13.5 11.56 13.434 11.375 13.3104C11.19 13.1868 11.0458 13.0111 10.9606 12.8055C10.8755 12.6 10.8532 12.3738 10.8966 12.1555C10.94 11.9373 11.0472 11.7368 11.2045 11.5795C11.3618 11.4222 11.5623 11.315 11.7805 11.2716C11.9988 11.2282 12.225 11.2505 12.4305 11.3356C12.6361 11.4208 12.8118 11.565 12.9354 11.75C13.059 11.935 13.125 12.1525 13.125 12.375C13.125 12.6734 13.0065 12.9595 12.7955 13.1705C12.5845 13.3815 12.2984 13.5 12 13.5ZM16.125 17.25C15.9025 17.25 15.685 17.184 15.5 17.0604C15.315 16.9368 15.1708 16.7611 15.0856 16.5555C15.0005 16.35 14.9782 16.1238 15.0216 15.9055C15.065 15.6873 15.1722 15.4868 15.3295 15.3295C15.4868 15.1722 15.6873 15.065 15.9055 15.0216C16.1238 14.9782 16.35 15.0005 16.5555 15.0856C16.7611 15.1708 16.9368 15.315 17.0604 15.5C17.184 15.685 17.25 15.9025 17.25 16.125C17.25 16.4234 17.1315 16.7095 16.9205 16.9205C16.7095 17.1315 16.4234 17.25 16.125 17.25ZM16.125 13.5C15.9025 13.5 15.685 13.434 15.5 13.3104C15.315 13.1868 15.1708 13.0111 15.0856 12.8055C15.0005 12.6 14.9782 12.3738 15.0216 12.1555C15.065 11.9373 15.1722 11.7368 15.3295 11.5795C15.4868 11.4222 15.6873 11.315 15.9055 11.2716C16.1238 11.2282 16.35 11.2505 16.5555 11.3356C16.7611 11.4208 16.9368 11.565 17.0604 11.75C17.184 11.935 17.25 12.1525 17.25 12.375C17.25 12.6734 17.1315 12.9595 16.9205 13.1705C16.7095 13.3815 16.4234 13.5 16.125 13.5ZM19.5 7.5H4.5V4.5H6.75V5.25C6.75 5.44891 6.82902 5.63968 6.96967 5.78033C7.11032 5.92098 7.30109 6 7.5 6C7.69891 6 7.88968 5.92098 8.03033 5.78033C8.17098 5.63968 8.25 5.44891 8.25 5.25V4.5H15.75V5.25C15.75 5.44891 15.829 5.63968 15.9697 5.78033C16.1103 5.92098 16.3011 6 16.5 6C16.6989 6 16.8897 5.92098 17.0303 5.78033C17.171 5.63968 17.25 5.44891 17.25 5.25V4.5H19.5V7.5Z" fill="black" fill-opacity="0.88"/>
</svg>
`,
      false,
      false,
      '0px',
      menuSharedService,
      menuUtilsService
    );

    this.cacheService.getRouterGuardData().subscribe((res) => {
      const existsSellers = res.data.seller_amount > 0;
      const existsActiveSeller = res.data.sellers.some(
        (seller) => seller.seller_status.id === Global.VENDEDOR_ATIVO
      );
      const existsBatchAnticipation = res.data.batch_anticipation_amount > 0;
      if (existsSellers && existsActiveSeller) {
        this.children.push(
          new MenuItemChild(
            'Cartão de Crédito',
            '/pages/antecipacoes/antecipacao-transacao',
            false,
            true
          )
        );
      }

      if (existsBatchAnticipation) {
        this.children.push(
          new MenuItemChild(
            'Plano de Saúde',
            '/pages/antecipacoes/antecipacao-fatura',
            false,
            true
          )
        );
      }
    });

    this.menuSharedService.getSubItemsOf().subscribe((title) => {
      if (title === this.title && !this.showChildren) {
        this.showChildren = true;
        this.heightWhenShowingChildren = menuUtilsService.calculateSubmenuHeight(
          this.children
        );
      } else {
        this.showChildren = false;
        this.heightWhenShowingChildren = '0px';
      }
    });
  }

  async ngOnInit() {
    if (window.innerWidth <= 500 || screen.width <= 500) {
      this.isMobile = true;
    }

    this.menuSharedService.getMenuCollapsed().subscribe((menuCollapsed) => {
      this.menuCollapsed = menuCollapsed;
      this.heightWhenShowingChildren =
        menuCollapsed || this.isMobile ? '0px' : this.heightWhenShowingChildren;

      if (this.menuCollapsed && this.showChildren) {
        this.showChildren = false;
      }
    });
  }

  override toggleItemChildren() {
    super.toggleItemChildren();
    this.onClickSelect.emit({ title: this.title, children: this.children });
    this.isMobile = window.innerWidth <= 500 || screen.width <= 500 ? true : false;
  }

  override menuItemClicked() {
    super.menuItemClicked();
    this.onClickItem.emit();
  }
}
